import React, {ReactElement, useState} from "react";
import {Card, InputBase, Typography} from "@mui/material";
import {DIVIDER, PD_MD, PD_SM} from "@/shared/dimens";
import {mediumGray} from "@/shared/colors";

export function AnswerClassPopup({answerClasses, position, onSelect, onClose}: {
  answerClasses: string[],
  position: { x: number, y: number },
  onSelect: (answerClass: string) => void,
  onClose: () => void,
}): ReactElement {
  const [filter, setFilter] = useState("");
  const filtered = filter
    ? answerClasses.filter(ac => ac.toLowerCase().includes(filter.toLowerCase()))
    : answerClasses;
  return <>
    <div
      style={{position: "absolute", top: 0, left: 0, right: 0, bottom: 0, zIndex: 20}}
      onClick={onClose}
    />
    <Card style={{
      position: "absolute",
      left: position.x + 72,
      top: Math.min(window.innerHeight - 720, Math.max(48, position.y - 300)),
      zIndex: 21,
      width: 320,
      maxHeight: 600,
      overflowY:"scroll",
      padding: PD_MD,
      display: "flex",
      flexDirection: "column",
      gap: PD_SM,
    }}>
      <InputBase
        autoFocus
        placeholder="Filter labels..."
        value={filter}
        onChange={e => setFilter(e.target.value)}
        style={{
          borderBottom:DIVIDER,
          padding: `${PD_SM}px ${PD_MD}px`,
        }}
      />
      <Typography variant="subtitle2" style={{fontWeight: 600, marginTop: PD_SM}}>All choices</Typography>
      {filtered.map((ac, i) => (
        <div
          key={ac}
          onClick={() => onSelect(ac)}
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            padding: `${PD_SM}px ${PD_MD}px`,
            cursor: "pointer",
            borderRadius: 4,
          }}
          onMouseEnter={e => (e.currentTarget.style.background = mediumGray + "22")}
          onMouseLeave={e => (e.currentTarget.style.background = "")}
        >
          <Typography variant="body1">{ac}</Typography>
          <div style={{display: "flex", gap: 4}}>
            <Typography variant="caption" style={{
              background: mediumGray + "22",
              borderRadius: 4,
              padding: "2px 6px",
              color: mediumGray,
            }}>Opt</Typography>
            <Typography variant="caption" style={{
              background: mediumGray + "22",
              borderRadius: 4,
              padding: "2px 6px",
              color: mediumGray,
            }}>{i + 1}</Typography>
          </div>
        </div>
      ))}
    </Card>
  </>;
}
